import { api } from './client';

type Envelope<T> = { data: T };

export type VocabKind = 'type' | 'dept' | 'form' | 'confidentiality';

export type VocabEntry = {
  id: string;
  kind: VocabKind;
  code: string;
  label: string | null;
};

export type VocabList = {
  type: VocabEntry[];
  dept: VocabEntry[];
  form: VocabEntry[];
  confidentiality: VocabEntry[];
};

export const numberingVocabApi = {
  async list(): Promise<VocabList> {
    const { data } = await api.get<Envelope<VocabList>>('/numbering-vocab');
    return data.data;
  },

  async create(input: { kind: VocabKind; code: string; label?: string }): Promise<VocabEntry> {
    const { data } = await api.post<Envelope<VocabEntry>>('/numbering-vocab', input);
    return data.data;
  },

  async delete(uuid: string): Promise<void> {
    await api.delete(`/numbering-vocab/${uuid}`);
  },
};
